import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {HeaderComponent} from './core/header/header.component';
import {FooterComponent} from './core/footer/footer.component';
import {LeftNavComponent} from './core/left-nav/left-nav.component';
import {NavItemComponent} from './core/nav-item/nav-item.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {NavigationService} from "./core/services/navigation.service";
import {CirPublicDataInterceptor} from "./core/http/cir-public-data.interceptor";
import {MockHttpInterceptor} from "./core/http/mock-http.interceptor";
import {AbbreviateNumberPipe} from './core/pipes/abbreviate-number.pipe';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {environment} from "../environments/environment";
import {JsonapiHandlerService} from "./core/services/jsonapi.handler.service";
import {NotFoundComponent} from "./core/not-found/not-found.component";
import {HomeModule} from "./home/home.module";
import {AppRoutingModule} from "./app-routing.module";
import {MomentModule} from "ngx-moment";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LeftNavComponent,
    NavItemComponent,
    AbbreviateNumberPipe,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    HomeModule,
    MomentModule
  ],
  providers: [
    NavigationService,
    JsonapiHandlerService,
    {provide: HTTP_INTERCEPTORS, useClass: CirPublicDataInterceptor, multi: true},
    environment.mockBackend ? [{provide: HTTP_INTERCEPTORS, useClass: MockHttpInterceptor, multi: true}] : []
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
